exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-interface-text:hover,.editable-interface-text:hover{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:default}", ""]);

// exports
